<template>
	<div id="overview">
		<v-parallax
			dark
			src="https://firebasestorage.googleapis.com/v0/b/icbem2020-c618e.appspot.com/o/images%2Fvenue-image.jpg?alt=media&token=84da1724-8c3b-435c-8e7d-3c387f4e623d"
			height="600"
		>
			<v-layout align-start column justify-center>
				<div class="heading-text">
					<div class="heading-text-wrapper">
						<h2>{{ title }}</h2>
					</div>
					<div class="heading-text-wrapper">
						<h3>{{ subtitle }}</h3>
					</div>
				</div>

				<h2 class="sub-heading text-white">{{ location }}</h2>
				<h2 class="sub-heading text-white">{{ dates }}</h2>
			</v-layout>
		</v-parallax>
	</div>
</template>

<script>
export default {
	name: 'Overview',
	props: {
		title: String,
		subtitle: String,
		dates: String,
		location: String,
		state: String,
		country: String
	},
	methods: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.heading-text {
	padding: 32px;
	background-color: #fff;
	opacity: 0.8;
	margin-top: 32px;
	margin-left: 64px;
	margin-bottom: 1rem;
	width: 55vw;
}

.heading-text-wrapper {
	width: 100%;
}

.heading-text-wrapper h2 {
	color: #333;
	margin: 0;
	border-bottom: 2px solid var(--accent-color);
}

.heading-text-wrapper h3 {
	color: #333;
	margin: 0;
}

.sub-heading {
	margin-left: 64px;
}
</style>
